import actionCreator from '../../createAction';

const createAction = actionCreator('ivr');

export const GET_CALL_HOUR_GROUPS = createAction('GET_CALL_HOUR_GROUPS');
export const GET_CALL_MENUS = createAction('GET_CALL_MENUS');
export const GET_CALL_MENU_OPTIONS = createAction('GET_CALL_MENU_OPTIONS');
export const GET_CONTACT_CALLERS = createAction('GET_CONTACT_CALLERS');
export const DELETE_CONTACT_CALLER = createAction('DELETE_CONTACT_CALLER');
export const GET_TEAMS = createAction('GET_TEAMS');
export const DELETE_TEAM = createAction('DELETE_TEAM');

export const SAVE_CALL_HOUR_GROUP = createAction('SAVE_CALL_HOUR_GROUP');
export const SAVE_CALL_MENU = createAction('SAVE_CALL_MENU');
export const SAVE_CALL_MENU_OPTION = createAction('SAVE_CALL_MENU_OPTION');

export const GET_CALL_MENU = createAction('GET_CALL_MENU');

export const DELETE_CALL_MENU = createAction('DELETE_CALL_MENU');
export const DELETE_CALL_MENU_OPTION = createAction('DELETE_CALL_MENU_OPTION');

export const CALL_IN_PROGRESS = createAction('CALL_IN_PROGRESS');
